import { ref } from 'vue'
import type { Ref } from 'vue'

import { SfLog } from '@app/adapters/logger'
import SFetch from '@app/utils/sfetch'
import type { PinnedReport } from '@app/application/report/types'

export interface UsePinnedReportCardsReturn {
  reports: Ref<PinnedReport[]>
  loading: Ref<boolean>
  errored: Ref<boolean>
  fetchReports: () => Promise<void>
}

function currentCompanyParams(): {
  company_id: number
  firm_id: number
  _options: true
} {
  return {
    company_id: parseInt(window.Silverfin.currentCompanyId, 10),
    firm_id: parseInt(window.Silverfin.currentFirmId, 10),
    _options: true,
  }
}

export function reportsIndexPinnedCardsUrl(): string {
  return (
    window.Silverfin.Routes.pinned_reports_path(currentCompanyParams()) +
    '.json'
  )
}

export function presentModePinnedCardsUrl(): string {
  return window.Silverfin.Routes.client_meetings_pinned_reports_path(
    currentCompanyParams()
  )
}

export function usePinnedReportCards(
  buildUrl: () => string = reportsIndexPinnedCardsUrl
): UsePinnedReportCardsReturn {
  const reports = ref<PinnedReport[]>([])
  const loading = ref(true)
  const errored = ref(false)

  async function fetchReports(): Promise<void> {
    loading.value = true
    errored.value = false
    try {
      const data = await SFetch.json<PinnedReport[]>(buildUrl())
      reports.value = data ?? []
    } catch (error) {
      errored.value = true
      SfLog.error('Failed to load pinned report cards', {
        error: error instanceof Error ? error : new Error(String(error)),
      })
    } finally {
      loading.value = false
    }
  }

  return { reports, loading, errored, fetchReports }
}
